import { render } from "./AdaptiveUploaderBody.vue?vue&type=template&id=28fdfb7f&scoped=true"
import script from "./AdaptiveUploaderBody.vue?vue&type=script&lang=js"
export * from "./AdaptiveUploaderBody.vue?vue&type=script&lang=js"

import "./AdaptiveUploaderBody.vue?vue&type=style&index=0&id=28fdfb7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fdfb7f"]])

export default __exports__